import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TemplatesService } from 'src/app/modules/finance/services/templates.service'; // Ajuste o caminho se necessário
import { TableLazyLoadEvent } from 'primeng/table';
import {
  TableAction,
  TableColumn,
} from 'src/app/shared/models/table-config.model';

@Component({
  selector: 'app-template-list-modal',
  templateUrl: './template-list-modal.component.html',
  standalone: false,
})
export class TemplateListModalComponent implements OnInit {
  templates: any[] = [];
  allTemplates: any[] = [];
  totalItems = 0;
  loading = true;
  filter = '';

  // Colunas baseadas no seu TemplatesComponent, mas simplificadas para o modal
  tableColumns: TableColumn[] = [
    {
      field: 'name',
      header: 'TEMPLATE NAME',
      type: 'text',
      width: 'auto',
      sortable: true,
    },
    {
      field: 'port.name',
      header: 'PORT',
      type: 'text',
      width: '25%',
      sortable: true,
    },
    { field: 'actions', header: '', type: 'actions', width: '15%' },
  ];

  // Ação de Seleção
  tableActions: TableAction[] = [
    {
      label: 'Select',
      styleClass: 'p-button-outlined p-button-secondary font-bold h-8 text-xs',
      command: (row) => this.ref.close({ template: row }),
    },
  ];

  constructor(
    public ref: DynamicDialogRef,
    private templatesService: TemplatesService,
  ) {}

  ngOnInit() {
    this.loadAll();
  }

  loadAll() {
    this.loading = true;
    // Trazendo 1000 registros para garantir paginação local fluida
    this.templatesService.getTemplates(1000, 0, '').subscribe({
      next: (data: any) => {
        this.allTemplates = data.templates || [];
        this.totalItems = this.allTemplates.length;
        this.processData({ first: 0, rows: 10 });
      },
      error: () => (this.loading = false),
    });
  }

  loadLazy(event: TableLazyLoadEvent) {
    if (this.allTemplates.length) {
      this.processData(event);
    }
  }

  processData(event: TableLazyLoadEvent) {
    this.loading = true;
    let processed = [...this.allTemplates];

    // Filtro Local
    if (this.filter) {
      const lower = this.filter.toLowerCase();
      processed = processed.filter(
        (t) =>
          (t.name && t.name.toLowerCase().includes(lower)) ||
          (t.port?.name && t.port.name.toLowerCase().includes(lower)),
      );
    }

    // Ordenação Local (Simples)
    if (event.sortField) {
      const field = event.sortField as string;
      const order = event.sortOrder || 1;

      processed.sort((a, b) => {
        let val1 = this.resolveFieldData(a, field);
        let val2 = this.resolveFieldData(b, field);

        if (val1 == null) return -1;
        if (val2 == null) return 1;

        if (typeof val1 === 'string') val1 = val1.toLowerCase();
        if (typeof val2 === 'string') val2 = val2.toLowerCase();

        if (val1 < val2) return -1 * order;
        if (val1 > val2) return 1 * order;
        return 0;
      });
    }

    this.totalItems = processed.length;
    const first = event.first || 0;
    const rows = event.rows || 10;

    this.templates = processed.slice(first, first + rows);

    // Pequeno delay para evitar flicker
    setTimeout(() => (this.loading = false), 100);
  }

  handleSearch(val: string) {
    this.filter = val;
    this.processData({ first: 0, rows: 10 });
  }

  closeModal() {
    this.ref.close();
  }

  // Helper para campos aninhados (ex: port.name)
  resolveFieldData(data: any, field: string): any {
    if (data && field) {
      if (field.indexOf('.') == -1) return data[field];
      else {
        let fields: string[] = field.split('.');
        let value = data;
        for (let i = 0, len = fields.length; i < len; ++i) {
          if (value == null) return null;
          value = value[fields[i]];
        }
        return value;
      }
    }
    return null;
  }
}
